import { Component, OnInit, Input, Output, EventEmitter, OnDestroy } from '@angular/core';

import { SpecialFormControl } from '@utilities/SpecialForms';
import { FormGroup, AbstractControl, Validators, FormBuilder, FormGroupDirective, ValidatorFn, ValidationErrors } from '@angular/forms';
import { takeUntil, take, filter, switchMap, map, tap } from 'rxjs/operators';
import { Subject, Observable, BehaviorSubject } from 'rxjs';
import {MatTableDataSource} from '@angular/material/table';
import { UniqueIdGenerator } from '@utilities/UniqueIdGenerator';
import { isNullOrUndefined } from 'util';
import { ControlFormsService } from '@services/control-forms.service';

const PATRON_NUMERO = /^\d{1,2}$/;
const HOUR_PATTERN = /^[0-1]?[0-2]:[0-5][0-9]\s?(A. M.|P. M.|a. m.|p. m.)$/;

interface ScheduleModel {
  id: string;
  day: string;
  startTime: string;
  endingTime: string;
  duration: number;
} 


@Component({
  selector: 'control-schedule',
  templateUrl: './control-schedule.component.html',
  styleUrls: ['./control-schedule.component.scss']
})
export class ControlScheduleComponent implements OnInit, OnDestroy {
  @Input() sfcontrol: SpecialFormControl;
  @Output('blurAction') _blurAction: EventEmitter<any> = new EventEmitter();
  @Output('enterKey') _enterKey: EventEmitter<any> = new EventEmitter();

  public _schedules$ = new BehaviorSubject<ScheduleModel[]>([]);
  public _schedules: ScheduleModel[] = [];
  public dataSource = new MatTableDataSource([]);
  public titulo: string;
  public formStatus = false;
  public formularioDatos: FormGroup;
  public erroresFormulario = {
    day: '',
    startTime: '',
    endingTime: ''
  };

  public displayedColumns = ['day', 'startTime', 'endingTime', 'duration', 'delete'];
  public days = ['lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado', 'domingo'];
  
  private _addElement = new Subject<ScheduleModel>();
  private _deleteElement = new Subject<string>();
  private _finisher = new Subject<void>();
  private _startDay: string;

  private mensajesValidacion = {
    day: {
      required: 'Seleccione el día',
    },
    startTime: {
      required: 'Especifique la hora de inicio',
      // pattern: 'Debe adpartarse al patron ##:## am/pm'
    },
    endingTime: {
      required: 'Espeficique la hora final',
      // pattern: 'Debe adpartarse al patron ##:## am/pm'
    }
  };

  constructor( 
    private fb: FormBuilder,
    private _controlFormsService: ControlFormsService,
     ) {
    this.construyeFormulario();
  }

  private construyeFormulario(): void {
    this.formularioDatos = this.fb.group({
      day: [ '', [
        Validators.required,
        Validators.minLength(3),
        Validators.maxLength(50)
      ] ],
      startTime: [0, [
        Validators.required,
        // Validators.pattern(HOUR_PATTERN)
      ]],
      endingTime: [ '', [
        Validators.required,
        // Validators.pattern(HOUR_PATTERN)
      ] ]
    }, { validators: this.timeValidator() });

    this.formularioDatos.valueChanges
    .pipe( takeUntil( this._finisher ) )
    .subscribe(data => this.alCambiarValor(data));

  }

  private alCambiarValor(data?: any): void {
    if (!this.formularioDatos) {
      alert('No existe formularioDatos');
      return;
    }

    const formulario: FormGroup = this.formularioDatos;

    for (const campo in this.erroresFormulario) {
      if (campo in this.erroresFormulario) {
        const control: AbstractControl = formulario.get(campo);
        this.erroresFormulario[campo] = '';
        if (control && control.dirty && !control.valid) {
          const mensajes = this.mensajesValidacion[campo];
          for (const error in control.errors) {
            if (error in control.errors) {
              this.erroresFormulario[campo] += mensajes[error] + ' ';
            }
          }
        }
      }
    }
    this.formStatus = false;
    if (this.formularioDatos.status === 'VALID') {
      this.formStatus = true;
    }
  }


  ngOnInit() {
    this._controlFormsService.itemValueTime.pipe(takeUntil(this._finisher)).subscribe((nextValue) => {
      if(!nextValue){
        this.formularioDatos.get('startTime').disable();
        this.formularioDatos.get('endingTime').disable();
        this.formularioDatos.get('day').disable();
      }
    });

    this.sfcontrol.valueChanges
    .pipe(
      take(1) 
    ).subscribe( value => {
        let input = value as string;

        const data: ScheduleModel[] = input ? input.split('#').map( i => JSON.parse(i) ) : [];
    
        this._schedules$.next(data);
        this.dataSource.data = data;
      }
    );

    if (this.sfcontrol.data[0] instanceof Observable ) {
      this.sfcontrol.data[0]
        .pipe(
          filter( day => !isNullOrUndefined(day) ),
          takeUntil( this._finisher )
        )
        .subscribe( i => {
            this._startDay = this.days[ i - 1 ];
            this.formularioDatos.get('day').setValue( this._startDay );
          } 
        );
    }

    this._schedules$.subscribe( data => {
        this._schedules = [...data];

        /* if (data.length === 0) {
          this.formularioDatos.get('day').disable();
        } else {
          this.formularioDatos.get('day').enable();
        } */

      } 
    );

    // AGREGAR
    this._addElement
      .pipe(
        filter( i => !isNullOrUndefined(i) ),
        switchMap( schedule => this._schedules$
          .pipe(
            map( lists => [...lists, schedule] ),
            take(1)
          ) 
        ),
        takeUntil( this._finisher )
      ).subscribe( i =>  {
          const data = [...i];//this.multipleSort( i );
          this._schedules$.next( data );
          this.dataSource.data = data;    
          this.updateValue( data );
        }   
      );

    // BORRAR
    this._deleteElement
      .pipe(
        filter( i => !isNullOrUndefined(i) ),
        switchMap( id => this._schedules$
          .pipe(
            map( list => list.filter( i => i.id !== id) ),
            take(1)
          ) 
        ),
        takeUntil( this._finisher )
      ).subscribe( data => {
        this._schedules$.next( data );
        this.dataSource.data = data;
        this.updateValue( data );
        } 
      );

  }

  // Si el listado de programas está vacío, entonces
  // no se debe cambiar la opción del selector



  public onSubmit(directivaFormulario: FormGroupDirective): void {
    const data = this.formularioDatos.value;
    const stateDisableDay = this.formularioDatos.get('day').disabled;

    let newDay: string;
    if (stateDisableDay) {
      newDay = this._startDay;
    } else {
      newDay = this.formularioDatos.get('day').value;
    }

    const horaInicio = this.hoursToNumbers(data['startTime']);
    const horaFinal = this.hoursToNumbers(data['endingTime']);
    const duration =  horaFinal - horaInicio;
    if (duration > 0) {
      const dataTime: ScheduleModel = {
        ...data, 
        duration: duration,
        id: UniqueIdGenerator.generate(),
        day: newDay
      };

      this._addElement.next( dataTime );
  
      directivaFormulario.resetForm();
    }
  }

  public delete(data: string): void {
    this._deleteElement.next( data );
  }

  private updateValue( list: ScheduleModel[] ): void {
    this.sfcontrol.markAsDirty();
    this.sfcontrol.setValue(list.map( i => JSON.stringify(i)).join('#'));
  }


  /** Validador de función de tiempo */
  private timeValidator(): ValidatorFn {
    return (form: FormGroup): ValidationErrors | null => {
      const formValue = form.value;
      const startTime = this.hoursToNumbers(formValue['startTime']);
      const endingTime = this.hoursToNumbers(formValue['endingTime']);
      const day = formValue['day'] as string;
      const filteredScheduler = this._schedules.filter(i => i.day === day);

      let wrongPosition = false;
      for (let index = 0; index < filteredScheduler.length; index++) {
        const currentScheduler = filteredScheduler[index];
        const currentStartTimeScheduler = this.hoursToNumbers(currentScheduler.startTime);
        const currentEndingTimeScheduler = this.hoursToNumbers(currentScheduler.endingTime);

        /** Siguiente elemento */
        let nextScheduler: ScheduleModel;
        let nextStartTimeScheduler: number;
        let nextEndingTimeScheduler: number;
        if ( index + 1 <= filteredScheduler.length - 1 ) {
          nextScheduler = filteredScheduler[index + 1];
          nextStartTimeScheduler = this.hoursToNumbers(nextScheduler.startTime);
          nextEndingTimeScheduler = this.hoursToNumbers(nextScheduler.endingTime);  
        }
        /** fin siguiente elemento */

        /** Anterior elemento */
        let previousScheduler: ScheduleModel;
        let previousStartTimeScheduler: number;
        let previousEndingTimeScheduler: number;
        if (index - 1 >= 0 ) {
          previousScheduler = filteredScheduler[index - 1];
          previousStartTimeScheduler = this.hoursToNumbers(previousScheduler.startTime);
          previousEndingTimeScheduler = this.hoursToNumbers(previousScheduler.endingTime);  
        }
        /** fin anterior elemento */

        if ( previousScheduler && nextScheduler ) {

          /** Comprueba que no se solapen los bordes */
          if (startTime > previousStartTimeScheduler && startTime < previousEndingTimeScheduler) {
            wrongPosition = true;
          }
          if (endingTime > previousStartTimeScheduler && endingTime < previousEndingTimeScheduler) {
            wrongPosition = true;
          }

          if (startTime > currentStartTimeScheduler && startTime < currentEndingTimeScheduler) {
            wrongPosition = true;
          }
          if (endingTime > currentStartTimeScheduler && endingTime < currentEndingTimeScheduler) {
            wrongPosition = true;
          }

          if (startTime > nextStartTimeScheduler && startTime < nextEndingTimeScheduler) {
            wrongPosition = true;
          }
          if (endingTime > nextStartTimeScheduler && endingTime < nextEndingTimeScheduler) {
            wrongPosition = true;
          }
          /** Fin de comprobación de solapación de bordes */

          if (startTime <= previousStartTimeScheduler && endingTime >= previousEndingTimeScheduler) {
            wrongPosition = true;
          }

          if (startTime <= currentStartTimeScheduler && endingTime >= currentEndingTimeScheduler) {
            wrongPosition = true;
          }

          if (startTime <= nextStartTimeScheduler && endingTime >= nextEndingTimeScheduler ) {
            wrongPosition = true;  
          }

        } else if ( !previousScheduler && nextScheduler ) {
          
          /** Comprueba que no se solapen los bordes */
          if (startTime > currentStartTimeScheduler && startTime < currentEndingTimeScheduler) {
            wrongPosition = true;
          }
          if (endingTime > currentStartTimeScheduler && endingTime < currentEndingTimeScheduler) {
            wrongPosition = true;
          }

          if (startTime > nextStartTimeScheduler && startTime < nextEndingTimeScheduler) {
            wrongPosition = true;
          }
          if (endingTime > nextStartTimeScheduler && endingTime < nextEndingTimeScheduler) {
            wrongPosition = true;
          }
          /** Fin de comprobación de solapación de bordes */

          if (startTime <= currentStartTimeScheduler && endingTime >= currentEndingTimeScheduler) {
            wrongPosition = true;
          }

          if (startTime <= nextStartTimeScheduler && endingTime >= nextEndingTimeScheduler ) {
            wrongPosition = true;  
          }
        } else if ( previousScheduler && !nextScheduler ) {
         
          /** Comprueba que no se solapen los bordes */
          if (startTime > previousStartTimeScheduler && startTime < previousEndingTimeScheduler) {
            wrongPosition = true;
          }
          if (endingTime > previousStartTimeScheduler && endingTime < previousEndingTimeScheduler) {
            wrongPosition = true;
          }

          if (startTime > currentStartTimeScheduler && startTime < currentEndingTimeScheduler) {
            wrongPosition = true;
          }
          if (endingTime > currentStartTimeScheduler && endingTime < currentEndingTimeScheduler) {
            wrongPosition = true;
          }
          /** Fin de comprobación de solapación de bordes */

          if (startTime < previousStartTimeScheduler && endingTime >= previousEndingTimeScheduler) {
            wrongPosition = true;
          }

          if (startTime < currentStartTimeScheduler && endingTime >= currentEndingTimeScheduler) {
            wrongPosition = true;
          }
        } else {
          /** Comprueba que no se solapen los bordes */

          if (startTime > currentStartTimeScheduler && startTime < currentEndingTimeScheduler) {
            wrongPosition = true;
          }
          if (endingTime > currentStartTimeScheduler && endingTime < currentEndingTimeScheduler) {
            wrongPosition = true;
          }
     
          /** Fin de comprobación de solapación de bordes */

          if (startTime <= currentStartTimeScheduler && endingTime >= currentEndingTimeScheduler) {
            wrongPosition = true;
          }

        }
     
      }

      return (startTime >= endingTime) || wrongPosition ? {'schedulerError': 'scheduler error'} : null;
    };
  }


  ngOnDestroy() {
    this._finisher.next();
  }

  private hoursToNumbers(input: string): number {
    if (input) {
      const index = input.indexOf(':');
      const hour = input.slice(0, index);
      const minute = input.slice(index+1);
      return Number(hour) + (Number(minute)/60);
    }
    return -1;
  }


  private multipleSort( entryList: ScheduleModel[] ): ScheduleModel[] {
    const outputList: ScheduleModel[] = [];
    entryList.sort( this.sortScheduleByDay );
    for (const day of this.days) {
      const data = entryList.filter( i => i.day === day);
      data.sort( this.sortScheduleByStartTime );
      data.forEach( i => outputList.push(i) );
    }
    return outputList;
  }
  

  private sortScheduleByDay( a: ScheduleModel, b: ScheduleModel ): number {

    const days = {
      'lunes': 1,
      'martes': 2,
      'miercoles': 3,
      'jueves': 4,
      'viernes': 5,
      'sabado': 6,
      'domingo': 7
    };

    if (days[a.day] > days[b.day]) {
      return 1;
    }

    if (days[a.day] < days[b.day]) {
      return -1;
    }
    return 0;
  }

  private sortScheduleByStartTime( a: ScheduleModel, b: ScheduleModel ): number {

    if (a.startTime > b.startTime) {
      return 1;
    }

    if (a.startTime < b.startTime) {
      return -1;
    }
    return 0;
  }


  
    // /** Calcula la fecha final del grupo */
    // private endDateCalculation(schedule: string, daysBlocked: string, startDate: string ): void {
    //   const objectDays: Object = {};
    //   if (schedule) {
    //     const data = schedule.split('#')
    //       .map( i => JSON.parse(i) )
    //       .map( i => ({day: i['day'], duration: +i['duration']}) );
  
    //     data.forEach( i => {
    //       if ( objectDays[i.day]) {
    //         objectDays[i.day] += i.duration;
    //       } else {
    //         Object.defineProperty( objectDays, i.day, {value: i.duration, enumerable: true, writable: true} );
    //       }
    //     });
  
    //     let days = 0;
    //     let residualTime = this._currentProgram ? +this._currentProgram.Duration : 0;
  
    //     while (residualTime > 0) {
    //       for (const key in objectDays) {
    //         if (objectDays.hasOwnProperty(key)) {
    //           const element = objectDays[key];
    //           residualTime -= element;
    //           days++;
    //           if (residualTime <= 0) {
    //             break;
    //           }
    //         }
    //       }  
    //     }
  
    //     const weekdays = ['domingo', 'lunes', 'martes', 'miercoles', 'jueves', 'viernes', 'sabado'];
  
    //     const schoolDays = Object.keys(objectDays);
  
    //     // DIAS BLOQUEADOS
    //     const arrangementBlockedDays = daysBlocked ? daysBlocked.split('#') : [];
    //     const activeDays: string[] = [];
  
    //     let referenceDate = startDate;
    //     let endDate: string;
    //     while (days > 0) {
  
    //       const nameDay = moment(referenceDate).weekday();
  
    //       if ( !arrangementBlockedDays.some( i => i === referenceDate) && schoolDays.some( i => i === weekdays[nameDay] )  ) {
    //         days--;
    //         activeDays.push(referenceDate);
    //         endDate = referenceDate;  
    //       }
    //       referenceDate = moment(referenceDate).add( 1, 'day' ).format('YYYY-MM-DD');
    //     }
  
    //      this.formGeneralInformation.patchValue({EndDate: endDate});
    //     this._endDate = endDate;
    //     this._activeDays = activeDays.join('#');
    //   }
  
    // }



}


